/* eslint-disable @typescript-eslint/no-explicit-any */

import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { cn } from "@/lib/utils";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { DocumentForm } from "./document-form";
import { DocumentAddressSelect } from "./document-address-select";
import { IfElseChain } from "@/components/shared/If-else-chain";
import { useState } from "react";
import { typeCheck } from "@/lib/type-check";
import { DocumentSupplierMappingSelect } from "./DocumentSupplierMappingSelect";

export const DocumentListingItem = ({
  keyValue,
  data,
  parentKey,
  isFirstRow,
  is_flagged,
}: any) => {
  const [state, setState] = useDocument();
  const isReadOnly = useDocumentReadOnly();
  const [active, setActive] = useState(false);
  const currentKey = parentKey.replace("detailsData.domain_json.", "");
  const temp1 = state.detailsData?.api_calls?.find((prop: any) =>
    Object.keys(prop).includes(currentKey.replace(".text", "")),
  );
  const currentDropDownInfo: any = temp1
    ? { key: Object.keys(temp1)[0], value: Object.values(temp1)[0] }
    : null;

  const types: any = typeCheck(data);

  const displayObjectValue = (dataProps: any) => {
    try {
      const tempData: any = JSON.stringify(dataProps, null, 2);
      return tempData
        .replaceAll("{", "")
        .replaceAll("}", "")
        .replaceAll(`""`, "");
    } catch (error) {
      console.log(error);
      return dataProps;
    }
  };

  return (
    <div
      className={cn(
        "relative flex w-full pr-2 text-[14px] items-center border border-slate-200  text-slate-400 border-l-0 border-r-0",
        isFirstRow ? "" : "border-t-0",
        "clear-both",
      )}
    >
      <div
        className={cn(
          "py-3 pl-0  text-left sm:break-normal sm:break-words break-anywhere z-[9] sticky left-0 ",
          "w-[150px]",
        )}
      >
        <span className="bg-white w-full inline-block">{keyValue}</span>
        <span className="absolute right-0">:</span>
      </div>
      <div
        className={cn(
          "relative flex items-center  pl-3 text-slate-600 text-left sm:break-normal sm:break-words break-anywhere ",
          "w-[calc(100%_-_150px)]",
        )}
      >
        {/* <pre>{JSON.stringify(currentKey, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
        <div
          className={cn(
            "w-full",
            is_flagged ? "bg-red-50 px-1 rounded-sm text-red-700 -ml-1" : "",
          )}
        >
          <IfElseChain
            conditions={[
              [
                currentDropDownInfo ? true : false,
                <>
                  {currentDropDownInfo?.value?.includes("supplier_mapping") ? (
                    <DocumentSupplierMappingSelect
                      keyValue={keyValue}
                      data={data}
                      parentKey={parentKey}
                      endPoint={currentDropDownInfo}
                    />
                  ) : (
                    <DocumentAddressSelect
                      keyValue={keyValue}
                      data={data}
                      parentKey={parentKey}
                      endPoint={currentDropDownInfo}
                    />
                  )}
                </>,
              ],
              [
                true,
                <ConditionRenderer condition={active}>
                  <DocumentForm
                    value={data}
                    onBlur={() => setActive(false)}
                    onChange={(prop: any) =>
                      setState({
                        type: "update-data",
                        data: {
                          key: parentKey,
                          value: prop,
                        },
                      })
                    }
                  />
                  <div
                    onClick={() => !isReadOnly && setActive(true)}
                    className={cn(
                      "inline-block h-full w-full cursor-pointer break-words",
                      // "w-[calc(100%_-_150px)]"
                    )}
                  >
                    <ConditionRenderer
                      condition={
                        typeof data === "string" || typeof data === "number"
                      }
                    >
                      <>{data}</>
                    </ConditionRenderer>
                    <ConditionRenderer condition={types === "Object"}>
                      <pre>{displayObjectValue(data)}</pre>
                    </ConditionRenderer>
                    <ConditionRenderer condition={types === "Array"}>
                      <>
                        {Array.isArray(data)
                          ? data
                              ?.map((item: any) => item?.text || "")
                              .filter((text: string) => text !== "")
                              .join(", ")
                          : ""}
                      </>
                    </ConditionRenderer>
                    <span className="opacity-0">-</span>
                  </div>
                </ConditionRenderer>,
              ],
            ]}
          />
        </div>
      </div>
    </div>
  );
};
